import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from 'semantic-ui-react'
import { connect } from 'react-redux'
import VersionsTable from '../components/versions-table'
import { getMetadata } from '../api/versions-utils'

class VersionsPage extends React.Component {
  constructor (props) {
    super()
    this.state = { metadata: null, brands: [] }
  }

  async retrieveMetadata (env) {
    this.setState({ metadata: await getMetadata(env) })
  }

  componentDidMount (nextProps) {
    this.retrieveMetadata(this.props.environment)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.environment !== this.props.environment) {
      this.setState({ metadata: null })
      this.retrieveMetadata(this.props.environment)
    }
  }

  render () {
    if (!this.state.metadata) { return null }
    return (
      <Grid centered>
        <Grid.Column width={15}>
          <div>
            <VersionsTable metadata={this.state.metadata} environment={this.props.environment} refreshOnClick={() => this.retrieveMetadata(this.props.environment)} />
          </div>
        </Grid.Column>
      </Grid>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    environment: state.environment.value
  }
}

VersionsPage.propTypes = {
  environment: PropTypes.string
}

export default connect(mapStateToProps)(VersionsPage)
